import { useEffect } from "react";

const TBA = () => {
  useEffect(() => {
    window.location.href = "/chat/1";
  }, []);
  return <>TO BE ADDED</>;
};
export default TBA;
